import { render, staticRenderFns } from "./Electricity.vue?vue&type=template&id=0975f72a&scoped=true"
import script from "./Electricity.vue?vue&type=script&lang=js"
export * from "./Electricity.vue?vue&type=script&lang=js"
import style0 from "./Electricity.vue?vue&type=style&index=0&id=0975f72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975f72a",
  null
  
)

export default component.exports